/* Atelier Noir — pinned paint-fill sequence. Fallback only: native scroll-driven
   CSS animation handles this where supported. Otherwise one passive rAF loop
   maps scroll position to --p (0 -> 1), completing the paint ~88% through. */
(() => {
  const RM = matchMedia('(prefers-reduced-motion: reduce)');

  class ScrollAtelier extends HTMLElement {
    connectedCallback() {
      if (RM.matches) {
        this.style.setProperty('--p', '1');
        return;
      }
      if (window.CSS && CSS.supports && CSS.supports('animation-timeline: view()')) return;
      this.track = this.querySelector('.sa-track');
      if (!this.track) return;
      this._on = () => {
        if (this._t) return;
        this._t = requestAnimationFrame(() => {
          this._t = 0;
          this.update();
        });
      };
      addEventListener('scroll', this._on, { passive: true });
      addEventListener('resize', this._on, { passive: true });
      this.update();
    }

    update() {
      const r = this.track.getBoundingClientRect();
      let p = (innerHeight - r.top) / r.height / 0.88;
      p = p < 0 ? 0 : p > 1 ? 1 : p;
      this.style.setProperty('--p', p.toFixed(4));
    }

    disconnectedCallback() {
      removeEventListener('scroll', this._on);
      removeEventListener('resize', this._on);
    }
  }

  if (!customElements.get('scroll-atelier')) customElements.define('scroll-atelier', ScrollAtelier);
})();
